export enum EventCodes {
  Ev0001 = 'RMAvailabilityReactApp.InlineSaveFreeFlex',
  Ev0002 = 'RMAvailabilityReactApp.PageVisit.EditAvailability',
  Ev0003 = 'RMAvailabilityReactApp.TrafficSource.StartDateInUrl',
  Ev0004 = 'RMAvailabilityReactApp.TrafficSource.EditAvailability',
  Ev0005 = 'RMAvailabilityReactApp.UserAction.UpdateClicked',
  Ev0006 = 'RMAvailabilityReactApp.PageLoad.EditAvailability',
  Ev0007 = 'RMAvailabilityReactApp.ResourceAssignment.ForecastUpdatedFromEsxp',
  Ev0008 = 'RMAvailabilityReactApp.ResourceAvailability.FetchedFromEsxp',
  Ev0082 = 'RMAvailabilityReactApp.YearlyCalendar.PageVisit',
  Ev0083 = 'RMAvailabilityReactApp.YearlyCalendar.DataLoad.Success',
  Ev0084 = 'RMAvailabilityReactApp.YearlyCalendar.DataLoad.Failure',
  Ev0085 = 'RMAvailabilityReactApp.YearlyCalendar.NonProject.Create',
  Ev0086 = 'RMAvailabilityReactApp.YearlyCalendar.NonProject.Update',
  Ev0087 = 'RMAvailabilityReactApp.YearlyCalendar.NonProject.Delete',
  Ev0088 = 'RMAvailabilityReactApp.YearlyCalendar.NonProject.OperationFailure',
  Ev0089 = 'RMAvailabilityReactApp.YearlyCalendar.Perf.LoadDuration',
}

export enum TelemetryFeatures {
  EditAvailability = 'EditAvailability',
  YearlyCalendar = 'YearlyCalendar',
}

export enum TelemetryActions {
  PageVisit = 'PageVisit',
  TrafficSource = 'TrafficSource',
  UserAction = 'UserAction',
  PageLoad = 'PageLoad',
}
export const TelemetryAppConstants = {
  AppId: 'cd4b1453-a9bd-4310-b0b1-275f060f8f83',
  ParentAppId: '1a438b3b-4474-429b-a8ea-f93d34b221fa',
};